import * as React from 'react';
import { Control } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Form_FieldArrayStringSection } from '../../../../../../react-commons/components/form/field-arrays/Form_FieldArrayStringSection';
import type { ExtractStringArrayKeys } from '../../../../../../react-commons/types/extractKeysOfType';
import { collapsiblesExpandedKeyChange } from '../../../../persisted/expanded-keys/expandedKeysActions';
import { DetailedValidationResource } from '../../../../resource/resources/validation/detailedValidationResource';
import { RootState } from '../../../../store/rootReducer';

export const Form_PropertyFieldArrayString = <T extends object>({
    name,
    control,
    readOnly,
    disabled = false,
    notCollapsible = false,
    onAddDefaultValue = () => '',
    initialOpen,
    label,
    parentId,
}: {
    name: (ExtractStringArrayKeys<T, false> | ExtractStringArrayKeys<T, true>) & string;
    control: Control<T>;
    initialOpen?: boolean;
    disabled?: boolean;
    notCollapsible?: boolean;
    readOnly: boolean;
    validationResources?: Array<DetailedValidationResource | undefined>; // TODO use or remove
    label: React.ReactNode;
    onAddDefaultValue?: () => string;
    parentId: string | undefined;
}) => {
    const dispatch = useDispatch();
    const isOpen = useSelector(
        (state: RootState) => state.persisted.expandedKeys.collapsiblesExpanded[`${label}_${parentId}`] ?? initialOpen
    );

    return (
        <Form_FieldArrayStringSection
            name={name}
            control={control}
            readOnly={readOnly}
            notCollapsible={notCollapsible}
            onAddDefaultValue={onAddDefaultValue}
            label={label}
            initialOpen={isOpen}
            handleExpansionChange={(value) => dispatch(collapsiblesExpandedKeyChange(`${label}_${parentId}`, value))}
            disabled={disabled}
        />
    );
};
